var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('app-header'),_c('div',{staticClass:"layout-container"},[_c('app-sidebar'),_c('div',{staticClass:"main-container",class:{ 'menu-hidden': _vm.hidden }},[_c('subscription-alert'),_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }